import { render, staticRenderFns } from "./QbTable.vue?vue&type=template&id=6202f3e8"
import script from "./QbTable.vue?vue&type=script&lang=js"
export * from "./QbTable.vue?vue&type=script&lang=js"
import style0 from "./QbTable.vue?vue&type=style&index=0&id=6202f3e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports